import { Dialog } from '@cmsgov/ds-medicare-gov';
import React, { useState } from 'react';
import StackingButtons from './stacking.buttons';
import Button from './button';
import TranslatedSpan from './translated.span';
import { useHistory } from 'react-router';
import translate from '../functions/translate';

export const PrivacyActDialog = () => {
   const [isOpen, setIsOpen] = useState(true);
   const history = useHistory();

   const getCancelButton = () => (
      <Button
         color={'teal'}
         displayAs={'button'}
         fill={'outlined'}
         onClick={cancel}
         size={'small'}
      >
         <TranslatedSpan english="Cancel" />
      </Button>
   );

   const getOkButton = () => (
      <Button
         color={'teal'}
         displayAs={'button'}
         fill={'solid'}
         onClick={ok}
         size={'small'}
      >
         <TranslatedSpan english="OK" />
      </Button>
   );

   const cancel = () => {
      history.push('/login');
   };

   const ok = () => {
      setIsOpen(false);
   };

   if (!isOpen) {
      return null;
   }

   return (
      <Dialog
         className="privacy-act"
         getApplicationNode={() => document.getElementById('App')}
         headerClassName={'drawer-dialog-header'}
         underlayClickExits={false}
      >
         {translate('The Centers for Medicare & Medicaid Services (CMS) collects information from Medicare beneficiaries to set up a secure account on Medicare.gov and provide personalized Medicare information to the beneficiary. 1851(d) of the Social Security Act (42 U.S.C. 1395w–21(d)) authorizes CMS to provide information and coverage options to Medicare beneficiaries on an internet site.')}
         <br />
         <br />
         {translate('CMS may use and disclose beneficiaries information as specified in the System of Records Notice (SORN) “1-800 Medicare Choice (HELPLINE),” System No. 09-70-0535, 66 FR 16679, March 27, 2001 and as permitted by the Privacy Act of 1974. Providing the requested information is voluntary; however, failure to provide this information may prevent creating an account.')}
         <StackingButtons 
            button1={getCancelButton()}
            button2={getOkButton()}
         />
      </Dialog>
   );
};
